import digitsOnly from '../../../../../form/field-validation/digitsOnly';
import addressee from '../../defaultFieldDefinitions/Addressee';
import addressLine2 from '../../defaultFieldDefinitions/AddressLine2';
import companyName from '../../defaultFieldDefinitions/CompanyName';
import county from '../../defaultFieldDefinitions/County';
import nameNumber from '../../defaultFieldDefinitions/HouseNameOrNumber';
import streetName from '../../defaultFieldDefinitions/StreetName';
import townCity from '../../defaultFieldDefinitions/TownCity';
import * as min from '../../minLengthValidators';
import * as max from '../../max-length-validators';
import * as required from '../../required-validators';

const FieldDefinitionIL = [
  addressee,
  {
    name: 'postCode',
    label: 'checkout.delivery.address.field.label.postal.code.text',
    required: true,
    minLength: 7,
    maxLength: 7,
    validate: [required.postCode, digitsOnly(), min.lengthPostCode(7), max.lengthPostCode(7)],
  },
  companyName,
  nameNumber,
  streetName,
  addressLine2,
  townCity,
  county,
];

export default FieldDefinitionIL;
